<template>
    <div class="all">
		<div class="text flex">
			<div class="box"></div>
			请输入用户id或靓号
		</div>
		<div style="padding:0 2px;display: flex">
			<input style="width: 350px;margin: 0 8px" placeholder="请输入用户id、靓号或手机号" v-model="number" type="text" maxlength="11" class="input" />
			<div class="sure" @click="surepay">确认用户</div>
		</div>
		<div class="text flex" v-if="sureInfo !== null">
			<div class="box"></div>
			确定用户
		</div>
		<div style="padding:0 20px;display: flex;align-items: center;" v-if="sureInfo !== null">
			<img :src="sureInfo.avatar_format" mode="cover" style="width: 60px;height: 60px;border-radius: 50%;" />
			<div style="margin-left: 20px;">{{sureInfo.nickname}}</div>
		</div>
		<div class="text flex">
			<div class="box"></div>
			<div>
				选择充值方式
			</div>
		</div>
		<div class="lists flex">
			<div class="list" :class="tab==index?'active':''" v-for="(item , index) in list" :key="index" @click="tabs(index)">
				{{item.price}}元
			</div>
		</div>
		<div class="but" @click="sendOrder()">
			确认支付
		</div>
	</div>
</template>
<script>
import axios from 'axios'
	export default {
        data() {
			return {
				tab: 0,
				number: null,
				money: null,
				show: false,
				list: [],
				code: '',
				card: '',
				lists: [],
				info: {},
				id:'',
				judge: false,
				new_id: '',
				sureInfo: null,
				nextRequest: true
			};
		},
        methods:{
            //获取充值列表
            async getpaylist() {
				axios.post('https://admin.uxiutv.com/api/recharge/rechargeConfig').then(res=>{
                    this.list = res.data.data.recharge_config
                    this.card = res.data.data.recharge_rules
                })
			},
            tabs(i) {
				this.tab = i
			},
            //确认充值对象
			async surepay() {
				if(this.number == null){
					// Toast('请输入用户信息')
					return
				}
				axios.post('https://admin.uxiutv.com/api/index/searchOneUser',{ keywords: this.number }).then(res=>{
                    this.sureInfo = {
                        avatar_format: res.data.data.avatar_format,
                        nickname: res.data.data.nickname
                    }
                    this.new_id = res.data.data.new_id
                    this.judge = true
                    console.log('this.sureInfo',res,this.sureInfo);
                })
			},
            // 提交订单
			async sendOrder(){
				if(!this.judge){
					// Toast('请先确认用户信息')
					return
				}
				console.log('this.nextRequest====>',this.nextRequest)
				if(!this.nextRequest) return
				this.nextRequest = false
				axios.post('https://ceshi.uxiutv.com/api/recharge/noNeedLoginSubmitOrder',{
                    recharge_id: this.list[this.tab].id,
                    // amount: this.money,
                    cover_uid: this.new_id,
                }).then(res=>{
                    if(res.data.code == 1){
                        console.log('window.location.origin',window.location.origin);
                        window.open(window.location.origin + '#/pay?order_id=' + res.data.data.order_id)
                    }
                });
			},
        },
        mounted() {
			this.getpaylist()
		},
    }
</script>

<style lang="scss">
.input{
    outline-color: #c5c5c5;
}
.sure{
		width: 100px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background-color: #FF4C7A;
		color: white;
		margin-left: 10px;
		border-radius: 34px;
	}
	.popall {
		padding: 20px 40px;
		box-sizing: border-box;
	}

	.all {

		box-sizing: border-box;

		.top {
			padding: 15px 10px;
			box-sizing: border-box;
			background-color: #f5f5f5;
			justify-content: space-between;

			.right {
				display: flex;
				align-items: center;
				font-size: 12px;
				color: #999999;
			}

			.left {
				.name {
					margin-left: 10px;
					font-weight: bold;
					font-size: 16px;
					color: #000;
				}

				image {
					width: 50px;
					height: 50px;
					border-radius: 50%;
				}
			}
		}

		.but {
			padding: 15px;
			width: 90%;
			margin: 20px auto;
			text-align: center;
			border-radius: 40px;
			background: #FF4C7A;


			font-weight: bold;
			font-size: 16px;
			padding: 10px 0;
			color: #FFFFFF;
		}

		.lists {
            display: flex;
			flex-wrap: wrap;
			// justify-content: center;

			.list {
				text-align: center;
				width: 29%;
				margin: 5px;
				background: #fff;
				border-radius: 40px 40px 40px 40px;
				border: 2px solid #dddddd;
				padding: 10px;
				box-sizing: border-box;
				font-weight: bold;
				box-sizing: border-box;
				font-size: 14px;
				color: #999999;
			}

			.active {
				text-align: center;
				width: 29%;
				background: #FF4C7A;
				border-radius: 40px 40px 40px 40px;
				border: 2px solid #FF575B;
				box-sizing: border-box;
				padding: 10px;
				box-sizing: border-box;
				font-weight: bold;
				font-size: 14px;
				color: #FFFFFF;
				box-shadow: 0 5px 2px 0 #cacaca;
			}
		}

		.text {
			font-weight: bold;
			font-size: 16px;
			color: #333333;
			margin: 15px 0;
            display: flex;
			.box {
				width: 4px;
				height: 14px;
				background: #FF4C7A;
				margin: 0 10px;
			}
		}
	}
</style>